import React, { useMemo, useState } from 'react';
import { CHARACTER_IMAGE_URLS, CHARACTER_IMAGE_NAMES } from '../../constants/characterImages';
import SpinnerLoader from './SpinnerLoader';

import './Loader.css';

const Loader: React.FC<{
  fullscreen?: boolean;
  size?: 'sm' | 'md' | 'lg';
  fullHeight?: boolean;
}> = ({ fullscreen = true, size = 'md', fullHeight = false }) => {
  const { imagePath, characterType } = useMemo(() => {
    const randomType =
      CHARACTER_IMAGE_NAMES[Math.floor(Math.random() * CHARACTER_IMAGE_NAMES.length)];
    return { imagePath: CHARACTER_IMAGE_URLS[randomType], characterType: randomType };
  }, []);

  const [imageError, setImageError] = useState(false);

  if (imageError) {
    return <SpinnerLoader fullscreen={fullscreen} />;
  }

  return (
    <div
      className={`flex items-center justify-center ${fullscreen ? 'min-h-screen' : fullHeight ? 'h-full' : ''}`}>
      <img
        src={imagePath}
        alt={`Loading ${characterType} animation`}
        className={`loader-image ${fullscreen ? 'max-h-24' : size === 'sm' ? 'max-h-12' : size === 'md' ? 'max-h-16' : 'max-h-24'}`}
        onError={() => setImageError(true)}
      />
    </div>
  );
};

export default Loader;
